import { ReactNode, useState, useContext, createContext } from 'react';

interface MfaCredentials {
  username: string;
  password: string;
}

interface MfaContextType {
  tempCredentials: MfaCredentials | null;
  setTempCredentials: (creds: MfaCredentials | null) => void;
}

const MfaContext = createContext<MfaContextType | undefined>(undefined);

export const MfaProvider = ({ children }: { children: ReactNode }) => {
  const [tempCredentials, setTempCredentials] = useState<MfaCredentials | null>(
    null,
  );

  return (
    <MfaContext.Provider value={{ tempCredentials, setTempCredentials }}>
      {children}
    </MfaContext.Provider>
  );
};

export const useMfa = () => {
  const context = useContext(MfaContext);
  if (context === undefined) {
    throw new Error('useMfa must be used within a MfaProvider');
  }
  return context;
};
